"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var LedgerItemResource = /** @class */ (function (_super) {
    tslib_1.__extends(LedgerItemResource, _super);
    function LedgerItemResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LedgerItemResource.endpoint = '/ledger';
    LedgerItemResource.MODEL_NAME = 'ledgeritem';
    return LedgerItemResource;
}(base_1.default));
exports.default = LedgerItemResource;
//# sourceMappingURL=ledgeritem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/ledgeritem.js
// module id = I/H3
// module chunks = 0